var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddressGpt = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#563BCE",
    d: "M21.75 12c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    fillRule: "evenodd",
    d: "M17.153 8.488A1.5 1.5 0 0 0 15.75 7.5H7.5c-.828 0-1.5.689-1.5 1.538v4.423C6 14.311 6.672 15 7.5 15h.375a.461.461 0 0 0 0-.922l-.375-.001a.61.61 0 0 1-.6-.616V9.088l3.99 2.408a1.26 1.26 0 0 0 1.473 0L16.35 9.09v3.21a.45.45 0 0 0 .9 0V9.038q-.002-.291-.098-.549Zm-1.403-.065H7.5a.6.6 0 0 0-.18.028l4.012 2.424c.16.12.43.12.588 0l4.011-2.423a.6.6 0 0 0-.181-.029",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    d: "M13.063 15.815c0 .262-.21.474-.47.474a.47.47 0 0 1-.468-.475c0-.262.21-.474.469-.474s.469.212.469.475m2.343.475a.47.47 0 0 0 .469-.475.47.47 0 0 0-.469-.475.47.47 0 0 0-.469.475c0 .262.21.474.47.474Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    fillRule: "evenodd",
    d: "M12.556 13.575a2.31 2.31 0 0 0-2.275 1.927h-.55a.561.561 0 1 0 0 .75h.549a2.31 2.31 0 0 0 2.276 1.936h2.888a2.31 2.31 0 0 0 2.276-1.935h.548a.561.561 0 0 0 .982-.376.562.562 0 0 0-.982-.375h-.549a2.31 2.31 0 0 0-2.275-1.927zm2.888.825h-2.888a1.481 1.481 0 0 0 0 2.963h2.888a1.481 1.481 0 0 0 0-2.963",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddressGpt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/address-gpt.e1d9e20b.svg";